"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MarkerFields;
var _react = _interopRequireDefault(require("react"));
var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));
var _cccisdFormik = require("cccisd-formik");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function MarkerFields(_ref) {
  var field = _ref.field,
    form = _ref.form;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Marker Value",
    name: "".concat(field.name, ".markers[0].value"),
    component: _cccisdFormik.CccisdInput,
    type: "number",
    min: 0,
    step: 0.1,
    placeholder: "none"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Marker Label",
    name: "".concat(field.name, ".markers[0].legend"),
    component: _cccisdFormik.CccisdInput
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Label Orientation",
    name: "".concat(field.name, ".markers[0].legendOrientation"),
    component: _cccisdFormik.CccisdSelect,
    options: ['vertical', 'horizontal'].map(function (o) {
      return {
        label: (0, _capitalize2["default"])(o),
        value: o
      };
    })
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Label Position",
    name: "".concat(field.name, ".markers[0].legendPosition"),
    component: _cccisdFormik.CccisdSelect,
    options: ['top-left', 'top', 'top-right', 'right', 'bottom-right', 'bottom', 'bottom-left', 'left'].map(function (o) {
      return {
        label: (0, _capitalize2["default"])(o),
        value: o
      };
    })
  }));
}